import permisosPresupuesto, { RESOURCE_PRESUPUESTO } from '@/auth/permissions/modules/presupuesto'
import { defineMenu } from '@/utils/menu'
import * as names from '@routes/presupuesto/nombres/configuracion'

const { configuracion } = permisosPresupuesto
export default defineMenu([
    {
        title: 'presupuesto.subopciones.bandeja_premisas',
        action: configuracion.bandejaPremisas,
        resource: RESOURCE_PRESUPUESTO,
        route: names.ROUTE_BANDEJA_PREMISAS,
    },
    {
        title: 'presupuesto.subopciones.crear_premisa',
        action: configuracion.crearPremisas,
        resource: RESOURCE_PRESUPUESTO,
        route: names.ROUTE_CREAR_PREMISAS,
    },
    {
        title: 'presupuesto.subopciones.niveles_aprobacion',
        action: configuracion.nivelAprobacion,
        resource: RESOURCE_PRESUPUESTO,
        route: names.ROUTE_BANDEJA_NIVEL_APROBACION,
    },
])
